import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import RoundedEditableImage from '../../components/rounded-editable-image/RoundedEditableImage';
import { getUserProfilePicture, isCropping, getUsersTmpProfilePicture } from '../user-selectors';
import { updateProfilePicture, cropProfilePicture } from '../user-actions';
import { showErrorModal } from '../../global-message/global-message-actions';

class EditProfileImage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hintTouchDown: false,
            cropping: false,
            isFetchingProfilePicture: false,
        };
    }

    render() {
        const { onDropRejected, updateImage, tmpImageUrl, imageUrl, cropHandler, isCroppingProfilePicture, imageSize } =
            this.props;
        return (
            <RoundedEditableImage
                onDropRejected={onDropRejected}
                updateImage={updateImage}
                tmpImageUrl={tmpImageUrl}
                imageUrl={imageUrl}
                cropHandler={cropHandler}
                isCropping={isCroppingProfilePicture}
                imageSize={imageSize}
                isFetching={this.state.isFetchingProfilePicture}
            />
        );
    }
}

EditProfileImage.propTypes = {
    imageSize: PropTypes.string.isRequired,
    updateImage: PropTypes.func.isRequired,
    onDropRejected: PropTypes.func.isRequired,
    cropHandler: PropTypes.func.isRequired,
    tmpImageUrl: PropTypes.string,
    imageUrl: PropTypes.string,
    isCroppingProfilePicture: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    tmpImageUrl: getUsersTmpProfilePicture(state),
    imageUrl: getUserProfilePicture(state),
    isCroppingProfilePicture: isCropping(state),
});

const mapDispatchToProps = (dispatch) => ({
    updateImage: (file) => dispatch(updateProfilePicture(file)),
    cropHandler: (crop) => dispatch(cropProfilePicture(crop)),
    onDropRejected: () => dispatch(showErrorModal('Bildefilen du prøver å laste opp støttes ikke')),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditProfileImage);
